import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef } from '../../services/modal.service';

import { I18nTranslator } from '../../i18n/translate';
import { Parcel } from '../../models/parcel.model';
import { ARBleService } from '../../services/agrorendement-ble.service';
import { ARColzaService } from '../../services/agrorendement-colza.service';
import { AROrgeService } from '../../services/agrorendement-orge.service';
import { ParcelService } from '../../services/parcel.service';
import { ParcelComponent } from './parcels.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';

export class ConfirmDeleteParcelDialogContext {
  parcelId: number;
  parent: ParcelComponent;
  showClose: boolean;
  isBlocking: boolean;
  size: string;
}

@Component({
  standalone: true,
  selector: 'confirm-del-parcel-dlg',
  templateUrl: 'confirm-delete-dialog.component.html',
  imports: [TranslatePipe, CommonModule],
  providers: [ParcelService, ARColzaService, ARBleService, AROrgeService],
})
export class ConfirmDeleteParcelDialogComponent implements OnInit {
  error: any;
  context: ConfirmDeleteParcelDialogContext;

  parcel: Parcel;

  constructor(
    public dialog: DialogRef<ConfirmDeleteParcelDialogContext>,
    private parcelService: ParcelService,
    private colzaService: ARColzaService,
    private bleService: ARBleService,
    private orgeService: AROrgeService,
    private i18nTranslator: I18nTranslator,
    private router: Router,
  ) {
    this.context = dialog.context;
  }

  ngOnInit() {
    this.parcelService.getParcel(this.context.parcelId).subscribe((parcel) => {
      this.parcel = parcel;
    });
  }

  confirmQuestionText(parcel: Parcel) {
    if (!parcel) {
      return '';
    }
    const parcelText = parcel.name + ' (PARC-' + parcel.id + ')';
    return this.i18nTranslator.translate('parcel.delete.confirm.question', parcelText);
  }

  confirmDelete(parcel: Parcel) {
    const obs1 = this.parcelService.getParcelStatuses([parcel.id]).subscribe((x) => {
      const p = x[0];
      if (p.toolStatuses) {
        if (p.toolStatuses.hasOwnProperty('ARColza')) {
          const toolStatuses: any = p.toolStatuses;
          const toolStatus = toolStatuses['ARColza'];
          if (toolStatus && toolStatus.hasDetailsStarted) {
            // TODO faire la séquence côté serveur ?
            this.colzaService.deleteParcelOrderItem(parcel).subscribe((data: any) => {
              this.callDeleteParcel(parcel);
            });
          } else {
            this.callDeleteParcel(parcel);
          }
        } else if (p.toolStatuses.hasOwnProperty('ARBle')) {
          const toolStatuses: any = p.toolStatuses;
          const toolStatus = toolStatuses['ARBle'];
          if (toolStatus && toolStatus.hasDetailsStarted) {
            this.bleService.deleteParcelOrderItem(parcel).subscribe((data: any) => {
              this.callDeleteParcel(parcel);
            });
          } else {
            this.callDeleteParcel(parcel);
          }
        } else if (p.toolStatuses.hasOwnProperty('AROrge')) {
          const toolStatuses: any = p.toolStatuses;
          const toolStatus = toolStatuses['AROrge'];
          if (toolStatus && toolStatus.hasDetailsStarted) {
            this.orgeService.deleteParcelOrderItem(parcel).subscribe((data: any) => {
              this.callDeleteParcel(parcel);
            });
          } else {
            this.callDeleteParcel(parcel);
          }
        } else {
          // TODO les outils ne sont pas nécessairement exclusifs
          this.callDeleteParcel(parcel);
        }
      } else {
        // pas d'outils disponibles pour la culture de la parcelle
        this.callDeleteParcel(parcel);
      }
    });
  }

  private callDeleteParcel(parcel: Parcel) {
    this.parcelService.delete(parcel).subscribe(
      (res) => {
        this.dialog.close();
        this.router.navigate(['/parcels']);
        this.context.parent.onChangeTable();
      },
      (error) => (this.error = error),
    );
  }

  dismiss() {
    this.dialog.close();
  }
}
